<button mat-raised-button color="primary" (click)="verifyToken()">Verify Token</button>
<button mat-raised-button color="accent" (click)="refreshToken()">Refresh Token</button>